import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { StyledAdminPoolConfigsListHeader } from './styles';
import { AdminListHeaderCell } from '../AdminListHeaderCell';
import { TSortAdminPoolConfigsByHeaderTitle } from 'types';

interface IPoolConfigsListHeaderProps {
  children?: React.ReactNode;
}

type FieldType = {
  key: TSortAdminPoolConfigsByHeaderTitle;
};

export const headerFields: FieldType[] = [
  { key: 'id' },
  { key: 'name' },
  { key: 'host' },
  { key: 'port' },
  { key: 'algorithm' },
  { key: 'user' },
  { key: 'password' },
];

export const AdminPoolConfigsListHeader = ({ children }: IPoolConfigsListHeaderProps) => {
  const { t } = useTranslation();

  return (
    <StyledAdminPoolConfigsListHeader>
      {headerFields.map(({ key }) => (
        <div key={key} className={cn('admin-list-header-cell-container', key.toLowerCase())}>
          <AdminListHeaderCell fieldKey={key}>
            {t(`adminPage.editPoolConfigs.listHeaders.${key}`)}
          </AdminListHeaderCell>
        </div>
      ))}

      <div className={cn('admin-list-header-cell-container', 'actions')}>
        <AdminListHeaderCell fieldKey="actions">
          {t('adminPage.editPoolConfigs.listHeaders.actions')}
        </AdminListHeaderCell>
      </div>
    </StyledAdminPoolConfigsListHeader>
  );
};
